import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { ICancerType } from "../interfaces/cancer-types.interface";

@Injectable({
  providedIn: "root",
})
export class CancerTypeService {
  constructor(private api: ApiService) {}

  /**
   * Fetch all available cancer types
   * @return The list of cancer types
   */
  public getCancerTypes(): Observable<ICancerType[]> {
    return this.api.get("cancer-types") as Observable<ICancerType[]>;
  }
}
